module.exports = __webpack_public_path__ + "img/loading.ed3aed4c.gif";